export default class UserStorage<T> {
    private _key: string;
    private _hash: {[key:string]:T}
    constructor(keyName:string){
        this._key = keyName;
        try {
            this._hash = JSON.parse(localStorage.getItem(keyName)||'{}')
        } catch(e){
            this._hash = {}
        }
    }
    get(key:string, defaultValue:T) : T {
        return this._hash[key] || defaultValue;
    }
    set(key:string, val:T|null) {
        if (val) this._hash[key] = val
        else delete this._hash[key]
        return this
    }
    addHash(key:string, val:{[key:string]:any}) {
        let ret = {...this.get(key, {} as T), ...val}
        this.set(key, ret)
        return this
    }
    save(){
        localStorage.setItem(this._key, JSON.stringify(this._hash))
    }
}